import type {
  SupervisorDateRange,
  SupervisorDateSearch,
} from '@/features/supervisor/types/supervisor';
import { type LocalDateRange, todayKeyInTimeZone } from '@/shared/lib/dateTime';
import { format } from 'date-fns';

export function resolveSupervisorDateRange(search: SupervisorDateSearch): SupervisorDateRange {
  const today = todayKeyInTimeZone();
  const validDateRange =
    search.dateFrom && search.dateTo && search.dateFrom <= search.dateTo
      ? { dateFrom: search.dateFrom, dateTo: search.dateTo }
      : { dateFrom: today, dateTo: today };
  return validDateRange;
}

export function supervisorDateRangeValue(
  scope: Pick<SupervisorDateRange, 'dateFrom' | 'dateTo'>,
): LocalDateRange {
  return {
    from: new Date(`${scope.dateFrom}T00:00:00`),
    to: new Date(`${scope.dateTo}T00:00:00`),
  };
}

export function supervisorDateRangeSearch(range: LocalDateRange | undefined): SupervisorDateSearch {
  if (!range?.from) return { dateFrom: undefined, dateTo: undefined };
  return {
    dateFrom: format(range.from, 'yyyy-MM-dd'),
    dateTo: format(range.to ?? range.from, 'yyyy-MM-dd'),
  };
}
